// Module
var code = " <iframe class=\"yt-player\" src=\"#\" frameborder=\"0\" allow=\"autoplay\" allowfullscreen> </iframe> ";
// Exports
module.exports = code;